import React from 'react';
import trim from 'lodash/fp/trim';

interface LazyImageProps {
  src: string;
  className: string;
}

export const LazyImage: React.FC<LazyImageProps> = ({
  src,
  className = '',
  ...props
}) => {
  const classNameWithLazyload = trim(`${className} lazyload`);
  return <img data-src={src} className={classNameWithLazyload} {...props} />;
};
